/**
 * Default PCW service catalog used to pre-populate Step 6's staffing schedule.
 *
 * Per the RN workflow, the Personal Care Worker rarely starts the week with
 * an empty grid — almost every client receives the same core set of ADL +
 * IADL services. Pre-populating the catalog flips the data-entry burden
 * from "type out every service" (slow + error-prone in-home) to "untick
 * what doesn't apply" (fast + safer for compliance).
 *
 * Rows mirror the wizard's `INITIAL_STATE.adl` / `INITIAL_STATE.iadl` keys
 * so the catalog stays in sync with the assessment side. The `key` field
 * lets the UI render a "Standard" badge so the nurse knows this row came
 * from the catalog (vs ones she added manually).
 *
 * Times are realistic PCW visit windows for an in-home morning + midday +
 * evening shift pattern.
 */

export const PCW_CATALOG = [
  // ---- AM block: morning ADL routine ----
  { key: "bathing",      time: "08:00", task: "Bathing / personal hygiene assistance" },
  { key: "dressing",     time: "08:00", task: "Dressing assistance (upper + lower)" },
  { key: "grooming",     time: "08:15", task: "Grooming — oral care, hair, shaving" },
  { key: "toileting",    time: "08:30", task: "Toileting / continence care" },
  { key: "transferring", time: "08:30", task: "Transferring — bed-to-chair, ambulation assist" },
  { key: "mobility",     time: "08:45", task: "Mobility assist / safety ambulation" },

  // ---- Midday block: nutrition + light IADL ----
  { key: "meal_prep_am", time: "12:00", task: "Meal preparation — lunch" },
  { key: "eating",       time: "12:15", task: "Eating / feeding assistance" },
  { key: "housekeeping", time: "13:00", task: "Light housekeeping — bedroom, bath" },
  { key: "laundry",      time: "13:30", task: "Laundry assistance" },

  // ---- PM block: evening routine ----
  { key: "meal_prep_pm", time: "18:00", task: "Meal preparation — dinner" },
  { key: "pm_adl",       time: "21:00", task: "Bedtime ADL routine — PM toileting, dressing" },
];

/**
 * Build a wizard staffing_schedule row from a catalog entry.
 * All 7 days default to checked; the RN unticks days/services not needed.
 */
export function catalogRowToScheduleRow(entry) {
  return {
    time: entry.time,
    task: entry.task,
    catalog_key: entry.key,        // tags this as a catalog-sourced row
    mon: true, tue: true, wed: true, thu: true, fri: true, sat: true, sun: true,
  };
}

/**
 * Build the full default staffing_schedule from PCW_CATALOG.
 * Used for first-time pre-populate AND the "Reset to default catalog" button.
 */
export function buildDefaultStaffingSchedule() {
  return PCW_CATALOG.map(catalogRowToScheduleRow);
}
